import { Typography } from "@mui/material";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

export type ResultStageLocalisations = {
    successMessage: string;
    errorMessage: string;
}

type ResultStageProps = {
    localisations: ResultStageLocalisations;
    isError: boolean;
};

function ResultStage(props: ResultStageProps) {
    return props.isError ? Error(props.localisations) : Success(props.localisations);
}

function Success({successMessage}: ResultStageLocalisations) {
    return (
        <>
            <Typography align="center" variant="h1" gutterBottom>
                {successMessage}
            </Typography>
            <Typography align="center" variant="h1" gutterBottom>
                <SentimentVerySatisfiedIcon fontSize="inherit" color="primary" aria-label="success-status"/>
            </Typography>
        </>
    );
}

function Error({ errorMessage }: ResultStageLocalisations) {
    return (
        <>
            <Typography align="center" variant="h1" gutterBottom>
                {errorMessage}
            </Typography>
            <Typography align="center" variant="h1" gutterBottom>
                <SentimentVeryDissatisfiedIcon fontSize="inherit" color="primary" />
            </Typography>
        </>
    );
}

export default ResultStage;
